import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { EstatusFolios } from 'app/shared/enum.shared';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState } from 'app/store/app.states';

@Component({
  selector: 'settings-folios',
  templateUrl: './folios.component.html',
  styleUrls: ['./folios.component.scss']
})
export class SettingsFoliosComponent implements OnInit, OnChanges {

  @Input() idEmpresa;
  nombreReporte;
  objetoGridConfiguration: any;
  objetosSelected;
  verGrid: boolean = false;
  resumen = {
    folios: 0,
    usados: 0,
    vencidos: 0,
    disponibles: 0
  }

  constructor(
    private coalService: CoalService,
    private _snackBar: MatSnackBar,
    private store: Store<AppState>,
    private router: Router
  ) {
    this.ObjectGrid();
  }

  ngOnInit(): void {
    this.getFolios();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.idEmpresa?.currentValue) {
      this.getFolios();
    }
  }

  getFolios() {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate=ope_empresa_paquetes.ope_empresa_paquete_hs.cat_paquete_estatus`)
    .subscribe((res: any) => {
      this.store.dispatch(OcultarSpinner());
      this.verGrid = true;
      this.objetoGridConfiguration.Data = res.data[0]?.attributes?.ope_empresa_paquetes?.data?.sort((a,b) => b.id - a.id);
      this.calculateFolios();
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
      error?.error?.error?.status === 400 ?
				this._snackBar.open(
					error?.error?.error?.message,
					'OK',
					{ duration: 5000 }
				) : 
        this._snackBar.open(
					'Algo salió mal. Por favor, vuelva a intentarlo.',
					'OK',
					{ duration: 5000 }
				);
    });
  }

  calculateFolios() {
    let folios = this.objetoGridConfiguration.Data;
    let activeFolios = folios.filter(function(paquete) {
        return this.indexOf(paquete?.attributes?.ope_empresa_paquete_hs?.data[0]?.attributes?.cat_paquete_estatus?.data?.id) < 0;
      }, [EstatusFolios.Cancelado, EstatusFolios.SolicitudEnviada]);
    let total = activeFolios.map(item => item.attributes?.folios).reduce((a,b) => a+b, 0);

    this.resumen.folios = total;
    this.resumen.vencidos = 0;
    this.resumen.usados = activeFolios.map(item => item.attributes?.usado).reduce((a,b) => a+b,0);
    this.resumen.disponibles = total - this.resumen.usados;
  }

  buyFolios() {
    this.router.navigate(['cuenta/paquetes']);
  }

  ObjectGrid() {
    let that = this;
    this.nombreReporte = 'Observaciones';
    this.objetoGridConfiguration = {
        GridOptions: {
            paginacion: 20,
            pageSize: ['40', '60', '80', '100'],
        },
        ExportExcel: { enabled: true, fileName: 'Folios' },
        ColumnHiding: { hide: true },
        Checkbox: { checkboxmode: 'single' },
        Editing: { allowupdate: true, mode: 'cell' },
        Columnchooser: { columnchooser: true },
        SearchPanel: {
            visible: true,
            width: 200,
            placeholder: 'Buscar...',
            filterRow: true,
        },
        Scroll: { mode: 'infinite' },
        Color: null,
        Detail: { detail: true },
        ToolbarDetail: null,
        ToolBox: [],
        Columns: [],
        Data: [],
        Columns1: [1],
        Data1: [],
        datosMessage(evento) {
            that.objetosSelected = evento.data;
        },
    };
    this.DataColumnsGrid();
  }

  DataColumnsGrid() {
    let columnsMulti = [];
      columnsMulti.push({
        caption: 'Paquete',
        dataField: 'attributes.paquete',
        allowEditing: false,
        fixed: true,
      });
      columnsMulti.push({
        caption: 'Precio',
        dataField: 'attributes.precio',
        allowEditing: false,
        format: '$#,##0.00'
      });
      columnsMulti.push({
        caption: 'Folios',
        dataField: 'attributes.folios',
        allowEditing: false,
      });
      columnsMulti.push({
        caption: 'Usados',
        dataField: 'attributes.usado',
        allowEditing: false,
      });
      columnsMulti.push({
        caption: 'Estatus',
        dataField: 'attributes.ope_empresa_paquete_hs.data[0].attributes.cat_paquete_estatus.data.attributes.paqueteEstatus',
        allowEditing: false,
      });
      columnsMulti.push({
        caption: 'Fecha',
        dataField: 'attributes.ope_empresa_paquete_hs.data[0].attributes.createdAt',
        dataType: 'date',
        allowEditing: false,
      });
    this.objetoGridConfiguration.Columns = columnsMulti;
  }

  datosMessage() {}
}
